import { render, staticRenderFns } from "./LsSelectUserPage.vue?vue&type=template&id=b6c2ccec&scoped=true"
import script from "./LsSelectUserPage.vue?vue&type=script&lang=js"
export * from "./LsSelectUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c2ccec",
  null
  
)

export default component.exports